import BouncedReceipt from '../../models/BouncedReceipt'
import { ApiAction, ApiState, initialApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface BouncedReceiptAzureState extends ApiState {
  doc?: BouncedReceipt
}

const BouncedReceiptsAzure = (state: BouncedReceiptAzureState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<BouncedReceiptAzureState>('BOUNCED_RECEIPT_AZURE')(state, action)
  }
}

export default BouncedReceiptsAzure
